/**
 * Created by Administrator on 2018/1/2.
 */
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { HttpService } from "../service/http-service";
import { FileUpload } from "../service/file-upload";
import { API } from "../config/api-config";
import { CommonService } from "../service/common";
declare var $: any;
@Component({
  templateUrl: "./fiveGoalTaskEdit.html",
})
export class FiveGoalTaskEdit implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private HttpService: HttpService,
    private location: Location,
    private fileupload: FileUpload,
    private common: CommonService
  ) {}

  private data: any = {
    active: 0,
    backgroundImage: "",
    description: "",
    endDate: "",
    id: 0,
    name: "",
    startDate: "",
    clockInImage: "",
  };

  private detailImages = [];
  private isCreate: boolean = false;
  public signData = [];
  private imagePath: string = "";

  ngOnInit(): void {
    this.getPath();
    this.route.params.subscribe((params) => {
      this.data.id = Number(params["id"]);
    });

    if (this.data.id != 0) {
      this.getData();
    } else {
      this.detailImages.push({ name: "", imagePath: "" });
      this.isCreate = true;
    }
    let self = this;
    $("#startDate")
      .datetimepicker({
        language: "zh-CN",
        format: "yyyy-mm-dd hh:ii:ss",
        todayBtn: 1,
        autoclose: true,
        startDate: this.common.dateFormat(new Date(), "yyyy-MM-dd hh:mm"),
      })
      .on("changeDate", function (ev) {
        $("#endDate").datetimepicker("setStartDate", $("#startDate").val());
        self.data.startDate = $(this).val();
      });
    $("#endDate")
      .datetimepicker({
        language: "zh-CN",
        format: "yyyy-mm-dd hh:ii:ss",
        todayBtn: 1,
        autoclose: true,
        startDate: this.common.dateFormat(new Date(), "yyyy-MM-dd hh:mm"),
      })
      .on("changeDate", function (ev) {
        $("#startDate").datetimepicker("setEndDate", $("#endDate").val());
        self.data.endDate = $(this).val();
      });
  }

  //获取全部数据
  private getData(): void {
    this.detailImages = [];
    this.HttpService.getData(API.getFiveGoal + "/" + this.data.id).then(
      (res) => {
        this.data = res.data;
        if (this.data.backgroundImage != "") {
          let dImages = this.data.backgroundImage.split("|");
          for (let i = 0; i < dImages.length; i++) {
            this.detailImages.push({
              name: dImages[i],
              imagePath: this.imagePath,
            });
          }
        }
        this.detailImages.push({ name: "", imagePath: "" });
      }
    );
  }

  private getPath(): void {
    this.HttpService.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
      console.log(res.data);
    });
  }

  private tempPath: string = API.getTemp;

  private removeDetailImage(index: number, event): void {
    event.stopPropagation();
    if (this.detailImages.length > 1) {
      if (this.detailImages[index].name != "") {
        this.detailImages.splice(index, 1);
      }
    }
  }

  private uploadDetailImage(index: number): void {
    let self = this;
    this.fileupload.upload(function (res) {
      let temRes = JSON.parse(res);
      if (temRes.status.code == 0) {
        if (self.detailImages[index].name == "") {
          self.detailImages.push({ name: "", imagePath: "" });
        }
        self.detailImages[index].name = temRes.data.fileName;
        self.detailImages[index].imagePath = self.tempPath;
      }
    });
  }

  // 获取图片路径
  private showImageEn: boolean = false;
  private showImageTc: boolean = false;
  private showclockInImage: boolean = false;
  private upload(name: string) {
    let self = this;
    this.fileupload.upload(function (res) {
      let temRes = JSON.parse(res);
      if (temRes.status.code == 0) {
        switch (name) {
          case "imageEn":
            self.showImageEn = true;
            break;
          case "imageTc":
            self.showImageTc = true;
            break;
          case "clockInImage":
            self.showclockInImage = true;
            break;
        }
        console.log(temRes);
        self.data[name] = temRes.data.fileName;
      }
    });
  }

  private submit(): void {
    let temImages = [];
    if (this.detailImages.length > 0) {
      for (let i = 0; i < this.detailImages.length; i++) {
        if (this.detailImages[i].name != "") {
          temImages.push(this.detailImages[i].name);
        }
      }
      this.data.backgroundImage = temImages.join("|");
    }
    this.HttpService.postData(API.postFiveGoalTask, this.data).then((res) => {
      if (res.status.code == 0 || res.status.code == "0") {
        this.location.back();
      } else {
        alert(res.status.message);
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/task/fiveGoalTaskEdit.component.ts